import axios from "axios";

const messagesAPI = axios.create({
  baseURL: "/api/messages/",
});

export default messagesAPI;
